<agu-item-card
    [Recommended]="Recommended"
    [IsNew]="Job.isNew"
    [Saved]="Job.itemState.saved"
    [Pinned]="Job.itemState.pinned"
    [ShowPin]="ShowPin"
    [ShowDismiss]="ShowDismiss"
    [ShowPinnedChip]="true"
    SaveLabel="Save job"
    (SaveToggled)="Save.emit($event)"
    (PinToggled)="Pin.emit($event)"
    (Dismissed)="Dismiss.emit()"
    (RowActivated)="Open.emit()"
>
    @for (tag of Tags; track tag) {
        <span chips class="agu-card__chip">{{ tag }}</span>
    }

    <!-- h2 on the Saved board (P/for-you.html:947). -->
    @if (TitleLevel === 2) {
        <h2 title class="ra-job-card__title">
            <button type="button" class="agu-card__title-btn" (click)="Open.emit()">{{ Job.title }}</button>
        </h2>
    } @else {
        <h3 title class="ra-job-card__title">
            <button type="button" class="agu-card__title-btn" (click)="Open.emit()">{{ Job.title }}</button>
        </h3>
    }

    <div sub class="ra-job-card__org-row">
        @if (LogoUrl) {
            <img [src]="LogoUrl" alt="" loading="lazy" referrerpolicy="no-referrer" class="ra-job-card__logo" (error)="OnLogoError()" />
        } @else {
            <span class="ra-job-card__initials" aria-hidden="true">{{ CompanyInitials }}</span>
        }
        <p class="ra-job-card__org">{{ MetaLine }}</p>
    </div>
    @if (AlsoIn) {
        <p sub class="ra-job-card__also">{{ AlsoIn }}</p>
    }
    @if (Snippet) {
        <p sub class="ra-job-card__snippet">{{ Snippet }}</p>
    }

    @if (Recommended && Job.reason) {
        <p why class="ra-job-card__why">
            <span class="ra-job-card__why-dot" aria-hidden="true">◆</span>
            <span>{{ Job.reason }}</span>
        </p>
    }

    <div ctas class="ra-job-card__foot">
        <div class="ra-job-card__salary">
            {{ SalaryLine }}
            @if (Job.salaryIsEstimated) {
                <small>Est. salary</small>
            }
        </div>
        <button type="button" class="agu-card__cta agu-card__cta--primary ra-job-card__cta" (click)="Open.emit()">View role</button>
    </div>
</agu-item-card>
